export interface User {
  id: string;
  name: string;
  avatar: string;
  phone: string;
  email: string;
  teams: string;
  position: string;
  reminder: boolean;
  sms: boolean;
}
// src/components/fakeUsers.ts
export const fakeUsers: User[] = [
  {
    id: "1",
    name: "Vicky Jacobs",
    avatar: "/photos/VJ_headshot.jpg",
    phone: "123-456-7890",
    email: "john.doe@example.com",
    teams: "Litigation",
    position: "Partner",
    reminder: true,
    sms: false,
  },
  {
    id: "2",
    name: "Reuben Greet-Smith",
    avatar: "/photos/photo_RGS.jpg",
    phone: "987-654-3210",
    email: "jane.smith@example.com",
    teams: "Mergers",
    position: "Senior Associate",
    reminder: false,
    sms: true,
  },
  {
    id: "3",
    name: "Faisal Sultan",
    avatar: "/photos/FS_Headshot.png",
    phone: "555-123-4567",
    email: "alice.johnson@example.com",
    teams: "Corporate",
    position: "Associate",
    reminder: true,
    sms: false,
  },
  {
    id: "4",
    name: "Bob Brown",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "444-555-6666",
    email: "bob.brown@example.com",
    teams: "Litigation",
    position: "Solicitor",
    reminder: false,
    sms: true,
  },
  {
    id: "5",
    name: "Charlie Green",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "222-333-4444",
    email: "charlie.green@example.com",
    teams: "Employment",
    position: "Trainee Solicitor",
    reminder: true,
    sms: false,
  },
  {
    id: "6",
    name: "Diana White",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "111-222-3333",
    email: "diana.white@example.com",
    teams: "Support",
    position: "Paralegal",
    reminder: false,
    sms: true,
  },
  {
    id: "7",
    name: "Edward Black",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "777-888-9999",
    email: "edward.black@example.com",
    teams: "Litigation",
    position: "Legal Secretary",
    reminder: true,
    sms: false,
  },
  {
    id: "8",
    name: "Fiona Blue",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "000-111-2222",
    email: "fiona.blue@example.com",
    teams: "Sales",
    position: "Admin",
    reminder: false,
    sms: true,
  },
  {
    id: "9",
    name: "George Yellow",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "333-444-5555",
    email: "george.yellow@example.com",
    teams: "Finance",
    position: "Admin",
    reminder: true,
    sms: false,
  },
  {
    id: "10",
    name: "Hannah Pink",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "666-777-8888",
    email: "hannah.pink@example.com",
    teams: "Legal",
    position: "Senior Associate",
    reminder: false,
    sms: true,
  },
  {
    id: "11",
    name: "Isabella Orange",
    avatar:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "123-789-4560",
    email: "isabella.orange@example.com",
    teams: "Human Resources",
    position: "HR Manager",
    reminder: true,
    sms: false,
  },
  {
    id: "12",
    name: "Jack Purple",
    avatar:
      "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "321-654-9870",
    email: "jack.purple@example.com",
    teams: "IT",
    position: "Software Engineer",
    reminder: false,
    sms: true,
  },
  {
    id: "13",
    name: "Karen Red",
    avatar:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "555-777-3333",
    email: "karen.red@example.com",
    teams: "Marketing",
    position: "Marketing Specialist",
    reminder: true,
    sms: false,
  },
  {
    id: "14",
    name: "Leo Blue",
    avatar:
      "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "444-888-9999",
    email: "leo.blue@example.com",
    teams: "Operations",
    position: "Operations Manager",
    reminder: false,
    sms: true,
  },
  {
    id: "15",
    name: "Mia White",
    avatar:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "222-444-6666",
    email: "mia.white@example.com",
    teams: "Customer Support",
    position: "Support Agent",
    reminder: true,
    sms: false,
  },
  {
    id: "16",
    name: "Nathan Brown",
    avatar:
      "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "333-666-9999",
    email: "nathan.brown@example.com",
    teams: "IT",
    position: "DevOps Engineer",
    reminder: false,
    sms: true,
  },
  {
    id: "17",
    name: "Olivia Green",
    avatar:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "123-456-7891",
    email: "olivia.green@example.com",
    teams: "Corporate",
    position: "Paralegal",
    reminder: true,
    sms: false,
  },
  {
    id: "18",
    name: "Peter Grey",
    avatar:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "789-012-3456",
    email: "peter.grey@example.com",
    teams: "Litigation",
    position: "Senior Associate",
    reminder: false,
    sms: true,
  },
  {
    id: "19",
    name: "Quinn Black",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "456-789-0123",
    email: "quinn.black@example.com",
    teams: "Finance",
    position: "Legal Secretary",
    reminder: true,
    sms: false,
  },
  {
    id: "20",
    name: "Rachel Brown",
    avatar:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    phone: "789-123-4567",
    email: "rachel.brown@example.com",
    teams: "Employment",
    position: "Trainee Solicitor",
    reminder: false,
    sms: true,
  },
];
export interface MyLatestReminderList {
  reminderList: Array<{
    id: string;
    title: string; // 2 weeks before, 1 week before, etc.
    datetime: string;
    matterId: string;
    party: "Claimant" | "Defendant" | "All Parties";
    type: "event" | "reminder";
    summary: string;
    documentId?: string;
    calendarReminder?: boolean;
    smsReminder?: boolean;
    assignedUserIds: string[];
    location: string;
    parentId?: string | null;
  }>;
}

export const remindersAndEvents: MyLatestReminderList["reminderList"] = [
  {
    id: "event1",
    title: "Abacus v Clover | Claimant, Defendant | Preliminary hearing for solicitors, 9am",
    datetime: "2024-08-25T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "event",
    summary:
      "UPON HEARING the solicitors for the Claimant and the Defendant at a preliminary hearing on 25 August 2024;",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
  {
    id: "event1-reminder-2w",
    title: "2 weeks before | Abacus v Clover | Claimant, Defendant | Preliminary hearing for solicitors, 9am",
    datetime: "2024-08-11T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Preliminary hearing for solicitors on 25 August 2024 at 9am",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event1",
  },
  {
    id: "event1-reminder-1w",
    title: "1 week before | Abacus v Clover | Claimant, Defendant | Preliminary hearing for solicitors, 9am",
    datetime: "2024-08-18T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Preliminary hearing for solicitors on 25 August 2024 at 9am",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event1",
  },
  {
    id: "event1-reminder-72h",
    title: "72h before | Abacus v Clover | Claimant, Defendant | Preliminary hearing for solicitors, 9am",
    datetime: "2024-08-22T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Preliminary hearing for solicitors on 25 August 2024 at 9am",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event1",
  },
  {
    id: "event1-reminder-48h",
    title: "48h before | Abacus v Clover | Claimant, Defendant | Preliminary hearing for solicitors, 9am",
    datetime: "2024-08-23T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Preliminary hearing for solicitors on 25 August 2024 at 9am",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event1",
  },

  // Event 2: Hearing scheduled (2024)
  {
    id: "event2",
    title: "Abacus v Clover | All Parties | Hearing scheduled for 1 September 2024",
    datetime: "2024-09-01T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "event",
    summary: "HEARING DATE: 1 September 2024",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
  {
    id: "event2-reminder-2w",
    title: "2 weeks before | Abacus v Clover | All Parties | Hearing scheduled for 1 September 2024",
    datetime: "2024-08-18T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Hearing scheduled for 1 September 2024",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event2",
  },
  {
    id: "event2-reminder-1w",
    title: "1 week before | Abacus v Clover | All Parties | Hearing scheduled for 1 September 2024",
    datetime: "2024-08-25T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Hearing scheduled for 1 September 2024",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event2",
  },
  {
    id: "event2-reminder-72h",
    title: "72h before | Abacus v Clover | All Parties | Hearing scheduled for 1 September 2024",
    datetime: "2024-08-29T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Hearing scheduled for 1 September 2024",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event2",
  },
  {
    id: "event2-reminder-48h",
    title: "48h before | Abacus v Clover | All Parties | Hearing scheduled for 1 September 2024",
    datetime: "2024-08-30T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Hearing scheduled for 1 September 2024",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event2",
  },

  // Event 7: Disclose rental comparison matrix (2025)
  {
    id: "event7",
    title: 'Abacus v Clover | Claimant | "Disclose rental comparison matrix 4pm"',
    datetime: "2025-09-02T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "event",
    summary: "The Claimant shall disclose copies of the rental comparison matrix by 4pm on 2 September 2025",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
  {
    id: "event7-reminder-2w",
    title: '2 weeks before | Abacus v Clover | Claimant | "Disclose rental comparison matrix 4pm"',
    datetime: "2025-08-19T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "reminder",
    summary: "Reminder: Disclose rental comparison matrix by 4pm on 2 September 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event7",
  },
  {
    id: "event7-reminder-1w",
    title: '1 week before | Abacus v Clover | Claimant | "Disclose rental comparison matrix 4pm"',
    datetime: "2025-08-26T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "reminder",
    summary: "Reminder: Disclose rental comparison matrix by 4pm on 2 September 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event7",
  },
  {
    id: "event7-reminder-72h",
    title: '72h before | Abacus v Clover | Claimant | "Disclose rental comparison matrix 4pm"',
    datetime: "2025-08-30T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "reminder",
    summary: "Reminder: Disclose rental comparison matrix by 4pm on 2 September 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event7",
  },
  {
    id: "event7-reminder-48h",
    title: '48h before | Abacus v Clover | Claimant | "Disclose rental comparison matrix 4pm"',
    datetime: "2025-08-31T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "reminder",
    summary: "Reminder: Disclose rental comparison matrix by 4pm on 2 September 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event7",
  },

  // Event 8: Disclose relevant documents (2025)
  {
    id: "event8",
    title: "Abacus v Clover | All Parties | Disclose relevant documents by 4pm",
    datetime: "2025-09-05T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "event",
    summary: "The Parties shall disclose all relevant documents by 4pm on 5 September 2025.",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
  {
    id: "event8-reminder-2w",
    title: "2 weeks before | Abacus v Clover | All Parties | Disclose relevant documents by 4pm",
    datetime: "2025-08-22T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Disclose all relevant documents by 4pm on 5 September 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event8",
  },
  {
    id: "event8-reminder-1w",
    title: "1 week before | Abacus v Clover | All Parties | Disclose relevant documents by 4pm",
    datetime: "2025-08-29T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Disclose all relevant documents by 4pm on 5 September 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event8",
  },
  {
    id: "event8-reminder-72h",
    title: "72h before | Abacus v Clover | All Parties | Disclose relevant documents by 4pm",
    datetime: "2025-09-02T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Disclose all relevant documents by 4pm on 5 September 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event8",
  },
  {
    id: "event8-reminder-48h",
    title: "48h before | Abacus v Clover | All Parties | Disclose relevant documents by 4pm",
    datetime: "2025-09-03T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Disclose all relevant documents by 4pm on 5 September 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event8",
  },
  {
    id: "event9",
    title: "Abacus v Clover | All Parties | Exchange witness statements by 4pm",
    datetime: "2025-09-29T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "event",
    summary: "Signed witness statements are to be exchanged by the parties by 4pm on 29 September 2025.",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
  {
    id: "event9-reminder-2w",
    title: "2 weeks before | Abacus v Clover | All Parties | Exchange witness statements by 4pm",
    datetime: "2025-09-15T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Exchange witness statements by 4pm on 29 September 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event9",
  },
  {
    id: "event9-reminder-1w",
    title: "1 week before | Abacus v Clover | All Parties | Exchange witness statements by 4pm",
    datetime: "2025-09-22T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Exchange witness statements by 4pm on 29 September 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event9",
  },
  {
    id: "event9-reminder-72h",
    title: "72h before | Abacus v Clover | All Parties | Exchange witness statements by 4pm",
    datetime: "2025-09-26T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Exchange witness statements by 4pm on 29 September 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event9",
  },
  {
    id: "event9-reminder-48h",
    title: "48h before | Abacus v Clover | All Parties | Exchange witness statements by 4pm",
    datetime: "2025-09-27T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Exchange witness statements by 4pm on 29 September 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event9",
  },

  // Event 10: Ground rules hearing (2025)
  {
    id: "event10",
    title: "Abacus v Clover | All Parties | Ground rules hearing at 10am",
    datetime: "2025-10-01T10:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "event",
    summary:
      "The case will be listed for a ground rules hearing at 10:00 am on 1 October 2025, allowing an estimated 2 hours.",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
  {
    id: "event10-reminder-2w",
    title: "2 weeks before | Abacus v Clover | All Parties | Ground rules hearing at 10am",
    datetime: "2025-09-17T10:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Ground rules hearing at 10am on 1 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event10",
  },
  {
    id: "event10-reminder-1w",
    title: "1 week before | Abacus v Clover | All Parties | Ground rules hearing at 10am",
    datetime: "2025-09-24T10:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Ground rules hearing at 10am on 1 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event10",
  },
  {
    id: "event10-reminder-72h",
    title: "72h before | Abacus v Clover | All Parties | Ground rules hearing at 10am",
    datetime: "2025-09-28T10:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Ground rules hearing at 10am on 1 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event10",
  },
  {
    id: "event10-reminder-48h",
    title: "48h before | Abacus v Clover | All Parties | Ground rules hearing at 10am",
    datetime: "2025-09-29T10:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Ground rules hearing at 10am on 1 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event10",
  },

  // Event 11: Defendant's expert name disclosure (2025)
  {
    id: "event11",
    title: "Abacus v Clover | Defendant | Defendant's expert name disclosure deadline",
    datetime: "2025-10-14T16:00:00",
    matterId: "ABC123",
    party: "Defendant",
    type: "event",
    summary: "The Defendant will inform the Claimant of the name of their expert by 14 October 2025",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
  {
    id: "event11-reminder-2w",
    title: "2 weeks before | Abacus v Clover | Defendant | Defendant's expert name disclosure deadline",
    datetime: "2025-09-30T16:00:00",
    matterId: "ABC123",
    party: "Defendant",
    type: "reminder",
    summary: "Reminder: Disclose expert name by 14 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event11",
  },
  {
    id: "event11-reminder-1w",
    title: "1 week before | Abacus v Clover | Defendant | Defendant's expert name disclosure deadline",
    datetime: "2025-10-07T16:00:00",
    matterId: "ABC123",
    party: "Defendant",
    type: "reminder",
    summary: "Reminder: Disclose expert name by 14 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event11",
  },
  {
    id: "event11-reminder-72h",
    title: "72h before | Abacus v Clover | Defendant | Defendant's expert name disclosure deadline",
    datetime: "2025-10-11T16:00:00",
    matterId: "ABC123",
    party: "Defendant",
    type: "reminder",
    summary: "Reminder: Disclose expert name by 14 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event11",
  },
  {
    id: "event11-reminder-48h",
    title: "48h before | Abacus v Clover | Defendant | Defendant's expert name disclosure deadline",
    datetime: "2025-10-12T16:00:00",
    matterId: "ABC123",
    party: "Defendant",
    type: "reminder",
    summary: "Reminder: Disclose expert name by 14 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event11",
  },

  // Event 12: Submit expert reports (2025)
  {
    id: "event12",
    title: "Abacus v Clover | All Parties | Submit expert reports by 4pm",
    datetime: "2025-10-15T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "event",
    summary: "The Parties are directed to submit expert reports by 4pm on 15 October 2025.",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
  {
    id: "event12-reminder-2w",
    title: "2 weeks before | Abacus v Clover | All Parties | Submit expert reports by 4pm",
    datetime: "2025-10-01T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Submit expert reports by 4pm on 15 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event12",
  },
  {
    id: "event12-reminder-1w",
    title: "1 week before | Abacus v Clover | All Parties | Submit expert reports by 4pm",
    datetime: "2025-10-08T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Submit expert reports by 4pm on 15 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event12",
  },
  {
    id: "event12-reminder-72h",
    title: "72h before | Abacus v Clover | All Parties | Submit expert reports by 4pm",
    datetime: "2025-10-12T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Submit expert reports by 4pm on 15 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event12",
  },
  {
    id: "event12-reminder-48h",
    title: "48h before | Abacus v Clover | All Parties | Submit expert reports by 4pm",
    datetime: "2025-10-13T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: Submit expert reports by 4pm on 15 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event12",
  },

  // Event 13: File reply to expert reports (2025)
  {
    id: "event13",
    title: "Abacus v Clover | All Parties | File reply to expert reports",
    datetime: "2025-10-31T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "event",
    summary: "The Parties are to file any reply to expert reports by 31 October 2025.",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
  {
    id: "event13-reminder-2w",
    title: "2 weeks before | Abacus v Clover | All Parties | File reply to expert reports",
    datetime: "2025-10-17T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: File reply to expert reports by 31 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event13",
  },
  {
    id: "event13-reminder-1w",
    title: "1 week before | Abacus v Clover | All Parties | File reply to expert reports",
    datetime: "2025-10-24T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: File reply to expert reports by 31 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event13",
  },
  {
    id: "event13-reminder-72h",
    title: "72h before | Abacus v Clover | All Parties | File reply to expert reports",
    datetime: "2025-10-28T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: File reply to expert reports by 31 October 2025",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event13",
  },
  {
    id: "event13-reminder-48h",
    title: "48h before | Abacus v Clover | All Parties | File reply to expert reports",
    datetime: "2025-10-29T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary: "Reminder: The Parties are to file any reply to expert reports by 31 October 2025.",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event13",
  },
  {
    id: "event14-reminder-2w",
    title: "2 weeks before | Abacus v Clover | Claimant | Request service quotation by 4pm",
    datetime: "2025-10-18T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "reminder",
    summary:
      "Reminder: The Claimant must by 4:00pm on 1 November 2025 request XYZ Intermediary Services to provide a quotation for the supply of services including necessary preparative work for the ground rules hearing and final hearing.",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event14",
  },
  {
    id: "event14-reminder-1w",
    title: "1 week before | Abacus v Clover | Claimant | Request service quotation by 4pm",
    datetime: "2025-10-25T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "reminder",
    summary:
      "Reminder: The Claimant must by 4:00pm on 1 November 2025 request XYZ Intermediary Services to provide a quotation for the supply of services including necessary preparative work for the ground rules hearing and final hearing.",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event14",
  },
  {
    id: "event14-reminder-72h",
    title: "72h before | Abacus v Clover | Claimant | Request service quotation by 4pm",
    datetime: "2025-10-29T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "reminder",
    summary:
      "Reminder: The Claimant must by 4:00pm on 1 November 2025 request XYZ Intermediary Services to provide a quotation for the supply of services including necessary preparative work for the ground rules hearing and final hearing.",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event14",
  },
  {
    id: "event14-reminder-48h",
    title: "48h before | Abacus v Clover | Claimant | Request service quotation by 4pm",
    datetime: "2025-10-30T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "reminder",
    summary:
      "Reminder: The Claimant must by 4:00pm on 1 November 2025 request XYZ Intermediary Services to provide a quotation for the supply of services including necessary preparative work for the ground rules hearing and final hearing.",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event14",
  },
  {
    id: "event15-reminder-2w",
    title: "2 weeks before | Abacus v Clover | All Parties | Pre-trial review, set timetable 9am",
    datetime: "2025-10-24T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary:
      "Reminder: A pre-trial review is scheduled for 7 November 2025, at which the court will consider any final issues before trial and set the trial timetable.",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event15",
  },
  {
    id: "event15-reminder-1w",
    title: "1 week before | Abacus v Clover | All Parties | Pre-trial review, set timetable 9am",
    datetime: "2025-10-31T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary:
      "Reminder: A pre-trial review is scheduled for 7 November 2025, at which the court will consider any final issues before trial and set the trial timetable.",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event15",
  },
  {
    id: "event15-reminder-72h",
    title: "72h before | Abacus v Clover | All Parties | Pre-trial review, set timetable 9am",
    datetime: "2025-11-04T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary:
      "Reminder: A pre-trial review is scheduled for 7 November 2025, at which the court will consider any final issues before trial and set the trial timetable.",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event15",
  },
  {
    id: "event15-reminder-48h",
    title: "48h before | Abacus v Clover | All Parties | Pre-trial review, set timetable 9am",
    datetime: "2025-11-05T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "reminder",
    summary:
      "Reminder: A pre-trial review is scheduled for 7 November 2025, at which the court will consider any final issues before trial and set the trial timetable.",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event15",
  },
  {
    id: "event16-reminder-2w",
    title: "2 weeks before | Abacus v Clover | Claimant | Send quotation to HMCTS by 16th",
    datetime: "2025-11-01T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "reminder",
    summary:
      "Reminder: The quotation must be sent by the Claimant to HMCTS for the attention of the court manager by 16 November 2025.",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event16",
  },
  {
    id: "event16-reminder-1w",
    title: "1 week before | Abacus v Clover | Claimant | Send quotation to HMCTS by 16th",
    datetime: "2025-11-08T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "reminder",
    summary:
      "Reminder: The quotation must be sent by the Claimant to HMCTS for the attention of the court manager by 16 November 2025.",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event16",
  },
  {
    id: "event16-reminder-72h",
    title: "72h before | Abacus v Clover | Claimant | Send quotation to HMCTS by 16th",
    datetime: "2025-11-13T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "reminder",
    summary:
      "Reminder: The quotation must be sent by the Claimant to HMCTS for the attention of the court manager by 16 November 2025.",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event16",
  },
  {
    id: "event16-reminder-48h",
    title: "48h before | Abacus v Clover | Claimant | Send quotation to HMCTS by 16th",
    datetime: "2025-11-14T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "reminder",
    summary:
      "Reminder: The quotation must be sent by the Claimant to HMCTS for the attention of the court manager by 16 November 2025.",
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: "event16",
  },
  {
    id: "event12",
    title: "Abacus v Clover | All Parties | Submit expert reports by 4pm",
    datetime: "2025-10-15T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "event",
    summary: "The Parties are directed to submit expert reports by 4pm on 15 October 2025.",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
  {
    id: "event13",
    title: "Abacus v Clover | All Parties | File reply to expert reports",
    datetime: "2025-10-31T16:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "event",
    summary: "The Parties are to file any reply to expert reports by 31 October 2025.",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
  {
    id: "event14",
    title: "Abacus v Clover | Claimant | Request service quotation by 4pm",
    datetime: "2025-11-01T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "event",
    summary:
      "The Claimant must by 4:00pm on 1 November 2025 request XYZ Intermediary Services to provide a quotation for the supply of services including necessary preparative work for the ground rules hearing and final hearing.",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
  {
    id: "event15",
    title: "Abacus v Clover | All Parties | Pre-trial review, set timetable 9am",
    datetime: "2025-11-07T09:00:00",
    matterId: "ABC123",
    party: "All Parties",
    type: "event",
    summary:
      "A pre-trial review is scheduled for 7 November 2025, at which the court will consider any final issues before trial and set the trial timetable.",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
  {
    id: "event16",
    title: "Abacus v Clover | Claimant | Send quotation to HMCTS by 16th",
    datetime: "2025-11-16T16:00:00",
    matterId: "ABC123",
    party: "Claimant",
    type: "event",
    summary:
      "The quotation must be sent by the Claimant to HMCTS for the attention of the court manager by 16 November 2025.",
    documentId: "Vicky_Demo_Court_Order_v1_1",
    calendarReminder: true,
    smsReminder: true,
    assignedUserIds: ["1", "2"],
    location: "COMMERCIAL COURT (QBD)",
    parentId: null,
  },
];

export interface Matter {
  id: string;
  title: string;
  assignedUserIds: string[];
  driveUrl: string;
  court: string;
  Claimant: string;
  Defendant: string;
  role: "Claimant" | "Defendant";
  startingDate: string;
}

export const matters: Matter[] = [
  // Existing matters
  {
    id: "ABC123",
    title: "Abacus Delta LTD vs Clover Offices LTD hearing on monopoly",
    assignedUserIds: ["1", "2"],
    driveUrl: "/file_upload/ABC123",
    court: "London Court of Appeal",
    Claimant: "Abacus Delta LTD",
    Defendant: "Clover Offices",
    role: "Claimant",
    startingDate: "2025-06-11T09:00:00Z",
  },
  // Additional matters
  {
    id: "QWE111",
    title: "Amazon vs eBay trademark dispute",
    assignedUserIds: ["1", "5"],
    driveUrl: "/file_upload/QWE111",
    court: "New York Supreme Court",
    Claimant: "Amazon",
    Defendant: "eBay",
    role: "Claimant",
    startingDate: "2025-07-03T10:00:00Z",
  },
  {
    id: "RTY222",
    title: "Clover Offices patent infringement",
    assignedUserIds: ["3", "7"],
    driveUrl: "/file_upload/RTY222",
    court: "San Francisco Superior Court",
    Claimant: "Google",
    Defendant: "Oracle",
    role: "Claimant",
    startingDate: "2025-07-05T11:00:00Z",
  },
  {
    id: "UIO333",
    title: "Abacus Delta employee poaching",
    assignedUserIds: ["6", "8"],
    driveUrl: "/file_upload/UIO333",
    court: "Los Angeles County Superior Court",
    Claimant: "Tesla",
    Defendant: "Rivian",
    role: "Claimant",
    startingDate: "2025-07-10T12:00:00Z",
  },
  {
    id: "PAS444",
    title: "Omega Ltd unfair competition",
    assignedUserIds: ["2", "9"],
    driveUrl: "/file_upload/PAS444",
    court: "California Superior Court",
    Claimant: "Spotify",
    Defendant: "Apple",
    role: "Claimant",
    startingDate: "2025-07-15T13:00:00Z",
  },
  {
    id: "DFG555",
    title: "Zeus LTD trade secrets",
    assignedUserIds: ["4", "10"],
    driveUrl: "/file_upload/DFG555",
    court: "New York Supreme Court",
    Claimant: "Uber",
    Defendant: "Lyft",
    role: "Claimant",
    startingDate: "2025-07-20T14:00:00Z",
  },
  {
    id: "JKL666",
    title: "Athena LTD patent dispute",
    assignedUserIds: ["11", "12"],
    driveUrl: "/file_upload/JKL666",
    court: "San Jose Superior Court",
    Claimant: "Zoom",
    Defendant: "Cisco Systems",
    role: "Claimant",
    startingDate: "2025-07-25T15:00:00Z",
  },
  {
    id: "BNM777",
    title: "Twitter vs Facebook data privacy",
    assignedUserIds: ["13", "14"],
    driveUrl: "/file_upload/BNM777",
    court: "San Francisco Superior Court",
    Claimant: "Twitter",
    Defendant: "Facebook",
    role: "Claimant",
    startingDate: "2025-07-30T16:00:00Z",
  },
  {
    id: "WER888",
    title: "Airbnb vs Booking.com market practices",
    assignedUserIds: ["15", "16"],
    driveUrl: "/file_upload/WER888",
    court: "New York Supreme Court",
    Claimant: "Airbnb",
    Defendant: "Booking.com",
    role: "Claimant",
    startingDate: "2025-08-01T17:00:00Z",
  },
  {
    id: "SDF999",
    title: "Intel vs AMD competitive practices",
    assignedUserIds: ["17", "18"],
    driveUrl: "/file_upload/SDF999",
    court: "California Superior Court",
    Claimant: "Intel",
    Defendant: "AMD",
    role: "Claimant",
    startingDate: "2025-08-05T18:00:00Z",
  },
  {
    id: "GHJ000",
    title: "Microsoft vs IBM cloud services",
    assignedUserIds: ["19", "20"],
    driveUrl: "/file_upload/GHJ000",
    court: "San Jose Superior Court",
    Claimant: "Microsoft",
    Defendant: "IBM",
    role: "Claimant",
    startingDate: "2025-08-10T09:00:00Z",
  },
  {
    id: "ZXC111",
    title: "Dell vs HP patent infringement",
    assignedUserIds: ["1", "2"],
    driveUrl: "/file_upload/ZXC111",
    court: "New York Supreme Court",
    Claimant: "Dell",
    Defendant: "HP",
    role: "Claimant",
    startingDate: "2025-08-15T10:00:00Z",
  },
  {
    id: "VBN222",
    title: "Netflix vs Hulu copyright infringement",
    assignedUserIds: ["3", "4"],
    driveUrl: "/file_upload/VBN222",
    court: "Los Angeles County Superior Court",
    Claimant: "Netflix",
    Defendant: "Hulu",
    role: "Claimant",
    startingDate: "2025-08-20T11:00:00Z",
  },
  {
    id: "MLK333",
    title: "Shopify vs Amazon marketplace practices",
    assignedUserIds: ["5", "6"],
    driveUrl: "/file_upload/MLK333",
    court: "San Francisco Superior Court",
    Claimant: "Shopify",
    Defendant: "Amazon",
    role: "Claimant",
    startingDate: "2025-08-25T12:00:00Z",
  },
  {
    id: "OIU444",
    title: "Snapchat vs Instagram user data",
    assignedUserIds: ["7", "8"],
    driveUrl: "/file_upload/OIU444",
    court: "California Superior Court",
    Claimant: "Snapchat",
    Defendant: "Instagram",
    role: "Claimant",
    startingDate: "2025-08-30T13:00:00Z",
  },
  {
    id: "LKJ555",
    title: "Adobe vs Autodesk design tools",
    assignedUserIds: ["9", "10"],
    driveUrl: "/file_upload/LKJ555",
    court: "New York Supreme Court",
    Claimant: "Adobe",
    Defendant: "Autodesk",
    role: "Claimant",
    startingDate: "2025-09-01T14:00:00Z",
  },
  {
    id: "MNB666",
    title: "PayPal vs Stripe payment processing",
    assignedUserIds: ["11", "12"],
    driveUrl: "/file_upload/MNB666",
    court: "San Francisco Superior Court",
    Claimant: "PayPal",
    Defendant: "Stripe",
    role: "Claimant",
    startingDate: "2025-09-05T15:00:00Z",
  },
  {
    id: "POI777",
    title: "Salesforce vs SAP enterprise solutions",
    assignedUserIds: ["13", "14"],
    driveUrl: "/file_upload/POI777",
    court: "California Superior Court",
    Claimant: "Salesforce",
    Defendant: "SAP",
    role: "Claimant",
    startingDate: "2025-09-10T16:00:00Z",
  },
  {
    id: "YTR888",
    title: "Alibaba vs JD.com e-commerce practices",
    assignedUserIds: ["15", "16"],
    driveUrl: "/file_upload/YTR888",
    court: "New York Supreme Court",
    Claimant: "Alibaba",
    Defendant: "JD.com",
    role: "Claimant",
    startingDate: "2025-09-15T17:00:00Z",
  },
  {
    id: "XCV999",
    title: "Spotify vs Pandora music streaming",
    assignedUserIds: ["17", "18"],
    driveUrl: "/file_upload/XCV999",
    court: "San Francisco Superior Court",
    Claimant: "Spotify",
    Defendant: "Pandora",
    role: "Claimant",
    startingDate: "2025-09-20T18:00:00Z",
  },
  {
    id: "ASD000",
    title: "Zoom vs Webex video conferencing",
    assignedUserIds: ["19", "20"],
    driveUrl: "/file_upload/ASD000",
    court: "California Superior Court",
    Claimant: "Zoom",
    Defendant: "Webex",
    role: "Claimant",
    startingDate: "2025-09-25T09:00:00Z",
  },
  // Add more matters if needed...
];

// export const old_reminders_events = [
// 	{
// 		id: "e1",
// 		title: "Abacus Delta LtD vs Clover Offices Ltd: Court Hearing",
// 		datetime: "2024-06-26T09:00:00Z",
// 		matterId: "ABC123",
// 		party: "Claimant",
// 		type: "event",
// 		summary: "Important court hearing for case ABC123",
// 		documentId: "doc1",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["2"],
// 		location: "London Court of Appeal",
// 	},
// 	{
// 		id: "r1",
// 		title: "2 days before Court Hearing Abacus Delta LtD vs Clover Offices Ltd",
// 		datetime: "2024-06-27T10:00:00Z",
// 		matterId: "ABC123",
// 		party: "Claimant",
// 		type: "reminder",
// 		summary: "Reminder: Court hearing in 2 days",
// 		documentId: "doc1",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["1", "2"],
// 		location: "London Court of Appeal",
// 	},
// 	{
// 		id: "e2",
// 		title: "Document Submission Deadline Abacus Delta LtD vs Clover Offices Ltd",
// 		datetime: "2024-06-28T13:00:00Z",
// 		matterId: "XYZ456",
// 		party: "Defendant",
// 		type: "event",
// 		summary: "Deadline for submitting documents for case XYZ456",
// 		documentId: "doc2",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["1", "2"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r2",
// 		title: "1 day before Document Submission Abacus Delta LtD vs Clover Offices Ltd",
// 		datetime: "2024-07-01T13:00:00Z",
// 		matterId: "XYZ456",
// 		party: "Defendant",
// 		type: "reminder",
// 		summary: "Reminder: Document submission in 1 day",
// 		documentId: "doc2",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["2", "3"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r2a",
// 		title: "1 day before witness statement Abacus Delta LtD vs Clover Offices Ltd",
// 		datetime: "2024-07-02T14:00:00Z",
// 		matterId: "XYZ456",
// 		party: "Defendant",
// 		type: "reminder",
// 		summary: "Reminder: Document submission in 1 day",
// 		documentId: "doc2",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["3"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r2b",
// 		title: "1 day before Document Submission",
// 		datetime: "2024-07-03T14:00:00Z",
// 		matterId: "XYZ456",
// 		party: "Defendant",
// 		type: "reminder",
// 		summary: "Reminder: Document submission in 1 day",
// 		documentId: "doc2",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["2", "3"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r2c",
// 		title: "1 day before Document Submission Abacus Delta Ltd",
// 		datetime: "2024-07-14T14:00:00Z",
// 		matterId: "XYZ456",
// 		party: "Defendant",
// 		type: "reminder",
// 		summary: "Reminder: Document submission in 1 day",
// 		documentId: "doc2",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["1", "2"],
// 		location: "Office",
// 	},
// 	{
// 		id: "e3",
// 		title: "Epic Games vs Alphabet LLC: Initial Witness Meeting",
// 		datetime: "2024-07-16T10:00:00Z",
// 		matterId: "DEF789",
// 		party: "All Parties",
// 		type: "event",
// 		summary: "First meeting with new client for case DEF789",
// 		documentId: "doc3",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["1"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r3",
// 		title: "2 days before Client Meeting",
// 		datetime: "2024-07-14T10:00:00Z",
// 		matterId: "DEF789",
// 		party: "All Parties",
// 		type: "reminder",
// 		summary: "Reminder: Client meeting in 2 days",
// 		documentId: "doc3",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["1", "2"],
// 		location: "Office",
// 	},
// 	{
// 		id: "e4",
// 		title: "Strategy Session",
// 		datetime: "2024-07-16T13:00:00Z",
// 		matterId: "GHI012",
// 		party: "Claimant",
// 		type: "event",
// 		summary: "Strategize for upcoming case GHI012",
// 		documentId: "doc4",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["2"],
// 		location: "Office",
// 	},
// 	{
// 		id: "e5",
// 		title: "Team Meeting",
// 		datetime: "2024-07-16T16:00:00Z",
// 		matterId: "GHI012",
// 		party: "All Parties",
// 		type: "event",
// 		summary: "Weekly team meeting",
// 		documentId: "doc5",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["1", "2"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r4",
// 		title: "1 day before Team Meeting",
// 		datetime: "2024-07-15T16:00:00Z",
// 		matterId: "GHI012",
// 		party: "All Parties",
// 		type: "reminder",
// 		summary: "Reminder: Team meeting in 1 day",
// 		documentId: "doc5",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["1", "3"],
// 		location: "Office",
// 	},
// 	// June events and reminders
// 	{
// 		id: "e6",
// 		title: "Initial Client Meeting",
// 		datetime: "2024-07-01T10:00:00Z",
// 		matterId: "JKL345",
// 		party: "Claimant",
// 		type: "event",
// 		summary: "First meeting with new client for case JKL345",
// 		documentId: "doc6",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["2"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r5",
// 		title: "2 days before Initial Client Meeting",
// 		datetime: "2024-07-30T10:00:00Z",
// 		matterId: "JKL345",
// 		party: "Claimant",
// 		type: "reminder",
// 		summary: "Reminder: Initial client meeting in 2 days",
// 		documentId: "doc6",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["2", "3"],
// 		location: "Office",
// 	},
// 	{
// 		id: "e7",
// 		title: "Witness Preparation",
// 		datetime: "2024-07-10T13:00:00Z",
// 		matterId: "MNO678",
// 		party: "Defendant",
// 		type: "event",
// 		summary: "Prepare witness for upcoming trial in case MNO678",
// 		documentId: "doc7",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["2"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r6",
// 		title: "2 days before Witness Preparation",
// 		datetime: "2024-07-08T13:00:00Z",
// 		matterId: "MNO678",
// 		party: "Defendant",
// 		type: "reminder",
// 		summary: "Reminder: Witness preparation in 2 days",
// 		documentId: "doc7",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["1", "2"],
// 		location: "Office",
// 	},
// 	{
// 		id: "e8",
// 		title: "Case Review",
// 		datetime: "2024-07-15T09:00:00Z",
// 		matterId: "PQR901",
// 		party: "Claimant",
// 		type: "event",
// 		summary: "Review progress and strategy for case PQR901",
// 		documentId: "doc8",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["3"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r7",
// 		title: "2 days before Case Review",
// 		datetime: "2024-07-13T09:00:00Z",
// 		matterId: "PQR901",
// 		party: "Claimant",
// 		type: "reminder",
// 		summary: "Reminder: Case review in 2 days",
// 		documentId: "doc8",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["2", "1"],
// 		location: "Office",
// 	},
// 	{
// 		id: "e9",
// 		title: "Deposition",
// 		datetime: "2024-07-15T14:00:00Z",
// 		matterId: "STU234",
// 		party: "Defendant",
// 		type: "event",
// 		summary: "Deposition of key witness in case STU234",
// 		documentId: "doc9",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["11"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r8",
// 		title: "2 days before Deposition",
// 		datetime: "2024-07-13T14:00:00Z",
// 		matterId: "STU234",
// 		party: "Defendant",
// 		type: "reminder",
// 		summary: "Reminder: Deposition in 2 days",
// 		documentId: "doc9",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["11", "12"],
// 		location: "Office",
// 	},
// 	// Additional events and reminders up to December...
// 	{
// 		id: "e10",
// 		title: "Case Hearing",
// 		datetime: "2024-07-01T10:00:00Z",
// 		matterId: "VWX345",
// 		party: "Claimant",
// 		type: "event",
// 		summary: "Hearing for case VWX345",
// 		documentId: "doc10",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["13"],
// 		location: "Old Bailey, London",
// 	},
// 	{
// 		id: "r9",
// 		title: "1 week before Case Hearing",
// 		datetime: "2024-08-24T10:00:00Z",
// 		matterId: "VWX345",
// 		party: "Claimant",
// 		type: "reminder",
// 		summary: "Reminder: Case hearing in 1 week",
// 		documentId: "doc10",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["13", "14"],
// 		location: "Old Bailey, London",
// 	},
// 	{
// 		id: "e11",
// 		title: "Discovery Meeting",
// 		datetime: "2024-08-15T13:00:00Z",
// 		matterId: "YZA567",
// 		party: "Defendant",
// 		type: "event",
// 		summary: "Discovery meeting for case YZA567",
// 		documentId: "doc11",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["15"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r10",
// 		title: "3 days before Discovery Meeting",
// 		datetime: "2024-08-12T13:00:00Z",
// 		matterId: "YZA567",
// 		party: "Defendant",
// 		type: "reminder",
// 		summary: "Reminder: Discovery meeting in 3 days",
// 		documentId: "doc11",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["15", "16"],
// 		location: "Office",
// 	},
// 	{
// 		id: "e12",
// 		title: "Settlement Conference",
// 		datetime: "2024-09-20T09:00:00Z",
// 		matterId: "BCD890",
// 		party: "All Parties",
// 		type: "event",
// 		summary: "Settlement conference for case BCD890",
// 		documentId: "doc12",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["17"],
// 		location: "Royal Courts of Justice, London",
// 	},
// 	{
// 		id: "r11",
// 		title: "1 day before Settlement Conference",
// 		datetime: "2024-09-19T09:00:00Z",
// 		matterId: "BCD890",
// 		party: "All Parties",
// 		type: "reminder",
// 		summary: "Reminder: Settlement conference in 1 day",
// 		documentId: "doc12",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["17", "18"],
// 		location: "Royal Courts of Justice, London",
// 	},
// 	{
// 		id: "e13",
// 		title: "Trial Preparation",
// 		datetime: "2024-10-15T13:00:00Z",
// 		matterId: "EFG123",
// 		party: "Claimant",
// 		type: "event",
// 		summary: "Prepare for trial in case EFG123",
// 		documentId: "doc13",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["19"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r12",
// 		title: "2 days before Trial Preparation",
// 		datetime: "2024-10-13T13:00:00Z",
// 		matterId: "EFG123",
// 		party: "Claimant",
// 		type: "reminder",
// 		summary: "Reminder: Trial preparation in 2 days",
// 		documentId: "doc13",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["19", "20"],
// 		location: "Office",
// 	},
// 	{
// 		id: "e14",
// 		title: "Trial Date",
// 		datetime: "2024-11-01T10:00:00Z",
// 		matterId: "HIJ456",
// 		party: "Defendant",
// 		type: "event",
// 		summary: "Trial for case HIJ456",
// 		documentId: "doc14",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["1"],
// 		location: "London Court of Appeal",
// 	},
// 	{
// 		id: "r13",
// 		title: "1 week before Trial Date",
// 		datetime: "2024-10-25T10:00:00Z",
// 		matterId: "HIJ456",
// 		party: "Defendant",
// 		type: "reminder",
// 		summary: "Reminder: Trial date in 1 week",
// 		documentId: "doc14",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["1", "2"],
// 		location: "London Court of Appeal",
// 	},
// 	{
// 		id: "e15",
// 		title: "Final Settlement",
// 		datetime: "2024-12-15T13:00:00Z",
// 		matterId: "KLM789",
// 		party: "All Parties",
// 		type: "event",
// 		summary: "Final settlement for case KLM789",
// 		documentId: "doc15",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["3"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r14",
// 		title: "3 days before Final Settlement",
// 		datetime: "2024-12-12T13:00:00Z",
// 		matterId: "KLM789",
// 		party: "All Parties",
// 		type: "reminder",
// 		summary: "Reminder: Final settlement in 3 days",
// 		documentId: "doc15",
// 		calendarReminder: true,
// 		smsReminder: false,
// 		assignedUserIds: ["3", "4"],
// 		location: "Office",
// 	},
// 	{
// 		id: "e16",
// 		title: "Follow-up Meeting",
// 		datetime: "2024-12-20T09:00:00Z",
// 		matterId: "NOP012",
// 		party: "Claimant",
// 		type: "event",
// 		summary: "Follow-up meeting for case NOP012",
// 		documentId: "doc16",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["5"],
// 		location: "Office",
// 	},
// 	{
// 		id: "r15",
// 		title: "1 day before Follow-up Meeting",
// 		datetime: "2024-12-19T09:00:00Z",
// 		matterId: "NOP012",
// 		party: "Claimant",
// 		type: "reminder",
// 		summary: "Reminder: Follow-up meeting in 1 day",
// 		documentId: "doc16",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["5", "6"],
// 		location: "Office",
// 	},
// 	// Add 19 more existing reminders and events here...

// 	// Additional reminders and events
// 	{
// 		id: "e17",
// 		title: "Trademark Dispute Hearing",
// 		datetime: "2024-07-01T10:00:00Z",
// 		matterId: "QWE111",
// 		party: "Claimant",
// 		type: "event",
// 		summary: "Hearing for trademark dispute between Amazon and eBay",
// 		documentId: "docQWE111",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["1", "5"],
// 		location: "New York Supreme Court",
// 	},
// 	{
// 		id: "r17",
// 		title: "2 days before Trademark Dispute Hearing",
// 		datetime: "2024-06-29T10:00:00Z",
// 		matterId: "QWE111",
// 		party: "Claimant",
// 		type: "reminder",
// 		summary: "Reminder: Trademark dispute hearing in 2 days",
// 		documentId: "docQWE111",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["1", "5"],
// 		location: "New York Supreme Court",
// 	},
// 	{
// 		id: "e18",
// 		title: "Patent Infringement Hearing",
// 		datetime: "2024-07-05T11:00:00Z",
// 		matterId: "RTY222",
// 		party: "Claimant",
// 		type: "event",
// 		summary: "Hearing for patent infringement case between Google and Oracle",
// 		documentId: "docRTY222",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["3", "7"],
// 		location: "San Francisco Superior Court",
// 	},
// 	{
// 		id: "r18",
// 		title: "1 day before Patent Infringement Hearing",
// 		datetime: "2024-07-04T11:00:00Z",
// 		matterId: "RTY222",
// 		party: "Claimant",
// 		type: "reminder",
// 		summary: "Reminder: Patent infringement hearing in 1 day",
// 		documentId: "docRTY222",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["3", "7"],
// 		location: "San Francisco Superior Court",
// 	},
// 	{
// 		id: "e19",
// 		title: "Employee Poaching Hearing",
// 		datetime: "2024-07-10T12:00:00Z",
// 		matterId: "UIO333",
// 		party: "Claimant",
// 		type: "event",
// 		summary: "Hearing for employee poaching case between Tesla and Rivian",
// 		documentId: "docUIO333",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["6", "8"],
// 		location: "Los Angeles County Superior Court",
// 	},
// 	{
// 		id: "r19",
// 		title: "2 days before Employee Poaching Hearing",
// 		datetime: "2024-07-08T12:00:00Z",
// 		matterId: "UIO333",
// 		party: "Claimant",
// 		type: "reminder",
// 		summary: "Reminder: Employee poaching hearing in 2 days",
// 		documentId: "docUIO333",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["6", "8"],
// 		location: "Los Angeles County Superior Court",
// 	},
// 	{
// 		id: "e20",
// 		title: "Unfair Competition Hearing",
// 		datetime: "2024-07-15T13:00:00Z",
// 		matterId: "PAS444",
// 		party: "Claimant",
// 		type: "event",
// 		summary: "Hearing for unfair competition case between Spotify and Apple",
// 		documentId: "docPAS444",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["2", "9"],
// 		location: "California Superior Court",
// 	},
// 	{
// 		id: "r20",
// 		title: "1 day before Unfair Competition Hearing",
// 		datetime: "2024-07-14T13:00:00Z",
// 		matterId: "PAS444",
// 		party: "Claimant",
// 		type: "reminder",
// 		summary: "Reminder: Unfair competition hearing in 1 day",
// 		documentId: "docPAS444",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["2", "9"],
// 		location: "California Superior Court",
// 	},
// 	{
// 		id: "e21",
// 		title: "Trade Secrets Hearing",
// 		datetime: "2024-07-20T14:00:00Z",
// 		matterId: "DFG555",
// 		party: "Claimant",
// 		type: "event",
// 		summary: "Hearing for trade secrets case between Uber and Lyft",
// 		documentId: "docDFG555",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["4", "10"],
// 		location: "New York Supreme Court",
// 	},
// 	{
// 		id: "r21",
// 		title: "3 days before Trade Secrets Hearing",
// 		datetime: "2024-07-17T14:00:00Z",
// 		matterId: "DFG555",
// 		party: "Claimant",
// 		type: "reminder",
// 		summary: "Reminder: Trade secrets hearing in 3 days",
// 		documentId: "docDFG555",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["4", "10"],
// 		location: "New York Supreme Court",
// 	},
// 	{
// 		id: "e22",
// 		title: "Patent Dispute Hearing",
// 		datetime: "2024-07-25T15:00:00Z",
// 		matterId: "JKL666",
// 		party: "Claimant",
// 		type: "event",
// 		summary: "Hearing for patent dispute case between Zoom and Cisco Systems",
// 		documentId: "docJKL666",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["11", "12"],
// 		location: "San Jose Superior Court",
// 	},
// 	{
// 		id: "r22",
// 		title: "1 week before Patent Dispute Hearing",
// 		datetime: "2024-07-18T15:00:00Z",
// 		matterId: "JKL666",
// 		party: "Claimant",
// 		type: "reminder",
// 		summary: "Reminder: Patent dispute hearing in 1 week",
// 		documentId: "docJKL666",
// 		calendarReminder: true,
// 		smsReminder: true,
// 		assignedUserIds: ["11", "12"],
// 		location: "San Jose Superior Court",
// 	},
// ];
